const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
// @ helpers
//const { LabelDate } = require('commonsComponents/labelDate');
//const { DATE_FORMAT_DAY_MONTH } = require('constants/index');

class ContractSectionRow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { contractLink, codbban, intervention } = this.props;
        // we will need this in the future
        // const labelDate = openingDate !== null ? <LabelDate date={openingDate} format={DATE_FORMAT_DAY_MONTH} language={getLanguage()} today={LABEL_DATE_TODAY} yesterday={LABEL_DATE_YESTERDAY}/> /> : null;
        const labelDate = null;
        return (
            <OKTableRow>
                <OKTableCell>
                    {labelDate}
                </OKTableCell>
                <OKTableCell>
                    <OKLink to={contractLink}>
                        {codbban}
                    </OKLink>
                </OKTableCell>
                <OKTableCell>
                    <span className="contract-section__owner">
                        {intervention}
                    </span>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

ContractSectionRow.propTypes = {
    contractLink: PropTypes.string.isRequired,
    codbban: PropTypes.string.isRequired,
    intervention: PropTypes.string.isRequired,
    openingDate: PropTypes.string
};

module.exports = ContractSectionRow;
